import TopNavigationLayoutPageContent from 'shared/Layouts/TopNavigationLayout/TopNavigationLayoutPageContent'
import useProjectTypesInspectionOverviewState from './hooks/useProjectTypesInspectionOverviewState'
import { ITreeGroup, ITreeLeaf } from 'shared/Tree/tree.types'
import Card from 'shared/Cards/Card'
import Tree from 'shared/Tree'
import useExpandAll from 'shared/Tree/ctrl/useExpandAll'
import useTreeExpandCtrl from 'shared/Tree/ctrl/useTreeExpandCtrl'
import Tag from 'shared/Tag'
import { useNavigate } from 'react-router-dom'

type InspectionOverviewTreeGroup = ITreeGroup<
  { id: string; name: string; description?: string; pendingToCheckCount?: number },
  string
>

type InspectionOverviewTreeLeaf = ITreeLeaf<
  { id: string; name: string; description?: string; duration: number },
  string
>

const CheckpointInspectionPage = () => {
  const navigate = useNavigate()
  const { items } = useProjectTypesInspectionOverviewState()

  const groups = items.reduce<InspectionOverviewTreeGroup[]>((acc, val) => {
    acc.push({ id: val.id, parentId: null, data: val })
    val.stages.forEach((stage) => acc.push({ id: stage.id, parentId: val.id, data: stage }))
    return acc
  }, [])

  const leafs = items.reduce<InspectionOverviewTreeLeaf[]>((acc, val) => {
    val.stages.forEach((stage) =>
      stage.checkpoints.forEach((checkpoint) => acc.push({ key: checkpoint.id, groupId: stage.id, data: checkpoint }))
    )
    return acc
  }, [])

  const expandAllCtrl = useExpandAll()
  const treeExpandCtrl = useTreeExpandCtrl(
    'checkpoints/inspection/overview',
    expandAllCtrl.isOpenAll,
    groups,
    leafs,
    expandAllCtrl.setIsOpenAll,
    expandAllCtrl.clickedOnExpandAll,
    expandAllCtrl.setClickedOnExpandAll
  )

  const renderGroup = (group: InspectionOverviewTreeGroup) => {
    return (
      <div className='tree-group'>
        <div className='flex-space-between'>
          <p>{group.data.name}</p>
          {group.data.pendingToCheckCount !== undefined && (
            <Tag
              theme={group.data.pendingToCheckCount ? 'primary' : 'secondary'}
              label={`${group.data.pendingToCheckCount}`}
            />
          )}
        </div>
      </div>
    )
  }

  const renderLeaf = (leaf: InspectionOverviewTreeLeaf) => {
    return (
      <div
        className='tree-leaf'
        style={{ width: '100%' }}
        onClick={() => navigate(`/checkpoint-inspection/${leaf.data.id}`)}
      >
        <div className='flex-space-between'>
          <p>{leaf.data.name}</p>
          <div>{leaf.data.description}</div>
        </div>
      </div>
    )
  }

  return (
    <TopNavigationLayoutPageContent type='default'>
      <div className='flex-lines'>
        <h2 className='text--heading-h4'>Типы проекта</h2>
        <div>
          <Card type='normal'>
            <Tree
              leafs={leafs}
              groups={groups}
              renderLeaf={renderLeaf}
              renderGroup={renderGroup}
              expandCtrl={treeExpandCtrl}
            />
          </Card>
        </div>
      </div>
    </TopNavigationLayoutPageContent>
  )
}

export default CheckpointInspectionPage
